

import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import * as toastr from "toastr";
import PrimaryButton from "@/vue/components/PrimaryButton.vue";
import Utils from "@/utilities/Utils";

import { MapOptions } from "@/model/pagePartOptions/MapOptions";

interface MapParameters {
    center: {
        lat: number;
        lng: number;
    };
    zoom: number;
    [key: string]: any;
}

// interface Marker {
//     position: {
//         lat: number;
//         lng: number;
//     };
//     title?: string;
//     icon?: string;
// }

declare const google: any;

@Component({ components: { PrimaryButton } })
export default class MapPartGoogle extends Vue {

    mounted() {
        // if (+this.options.latitude !== 0 || +this.options.longitude !== 0) {
        //     //this.center.lat = this.options.latitude;
        //     //this.center.lng = this.options.longitude;
        //     this.zoom = this.options.initialZoom < 1 ? 12 : this.options.initialZoom;
        // }

        this.loadGoogleMapsApi();
    }

    @Prop({ default: new MapOptions() })
    options!: MapOptions;

    @Prop({ default: false })
    isAdminView!: boolean;

    get latitudeText(): string { return String(Utils.roundDegrees(this.options?.latitude ?? 0)); }

    get longitudeText(): string { return String(Utils.roundDegrees(this.options?.longitude ?? 0)); }

    directionQuery: string = "";
    travelMode: string = "DRIVING";

    travelModeOptions = [
        { id: "DRIVING", description: "Driving" },
        { id: "BICYCLING", description: "Cycling" },
        { id: "TRANSIT", description: "Public Transport" },
        { id: "WALKING", description: "Walking" }
    ]

    //
    // --
    //

    private googleMap: any = null; // google.maps.Map | null = null;
    private googleMapMarkers: any = []; //google.maps.Marker[] = [];
    private directionsService: any = null;
    private directionsRenderer: any = null;
    private apiLoaded = false;

    @Watch("directionQuery")
    async onOriginChanged(): Promise<void> {
        if (!this.googleMap || !this.apiLoaded) return;
        // if origin is cleared, just reset the map
        if(Utils.isEmptyOrWhitespace(this.directionQuery)) {
            this.initializeMap();
        }
    }

    @Watch("travelMode")
    async onModeChanged(): Promise<void> {
        if (!this.googleMap || !this.apiLoaded) return;
        if(!Utils.isEmptyOrWhitespace(this.directionQuery)) {
            this.calculateAndDisplayRoute();
        }
    }

    private loadGoogleMapsApi() {

        if ((window as any).google && (window as any).google.maps) {
            //console.log("⭐ loadGoogleMapsApi - already loaded");
            this.apiLoaded = true;
            this.initializeMap();
            return;
        }

        const apiKey = "AIzaSyCgjFMaZXjDaeLXWZVGl1pA5LZ4EM-nKFk";

        const script = document.createElement("script");

        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initGoogleMap`;
        script.async = true;
        script.defer = true;

        (window as any).initGoogleMap = () => {
            //console.log("⭐ initGoogleMap callback");
            this.apiLoaded = true;
            this.initializeMap();
        };

        document.head.appendChild(script);
    }

    private initializeMap() {
        if (!this.apiLoaded) return;

        console.log("⭐ initializeMap");

        const mapContainer = this.$refs.googleMapRef as HTMLElement;

        if (!mapContainer) {
            console.error("Map container not found");
            return;
        }

        const mapParameters: MapParameters = {
            center: { lat: this.options.latitude, lng: this.options.longitude },
            zoom: this.options.initialZoom,
            mapTypeControl: false,
            streetViewControl: false
        };

        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer();

        this.googleMap = new google.maps.Map(mapContainer, mapParameters);

        this.directionsRenderer.setMap(this.googleMap);

        this.updateMarkers();
    }

    private updateMarkers() {
        if (!this.googleMap) return;

        // Clear existing markers
        this.googleMapMarkers.forEach((marker: any) => marker.setMap(null));
        this.googleMapMarkers = [];

        // Add new markers
        const marker = new google.maps.Marker({
            position: {
                lat: this.options.latitude,
                lng: this.options.longitude
            },
            map: this.googleMap,
            //title: "The place",
            icon: {
                url: "/map-marker.png",
                scaledSize: new google.maps.Size(32, 32),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(16, 16)
            }
        });

        this.googleMapMarkers.push(marker);
    }


    private async calculateAndDisplayRoute(event?: Event): Promise<void> {
        event?.preventDefault();
        if(Utils.isEmptyOrWhitespace(this.directionQuery)) {
            this.initializeMap();
            return;
        }
        try {
            // DRIVING, BICYCLING, TRANSIT, WALKING
            const response = await this.directionsService.route({
                origin: { query: this.directionQuery },
                destination: { query: `${this.latitudeText},${this.longitudeText}` },
                travelMode: this.travelMode });
            this.directionsRenderer.setDirections(response);
        } catch (error) {
            //console.log(typeof error);
            toastr.error("Unable to find a route from what you entered.", "Failed to Navigate");
        }
    }
}
